
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/nft-airdrop",
      function () {
        return require("private-next-pages/products/nft-airdrop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/nft-airdrop"])
      });
    }
  